if (!customElements.get('km-review-carousel')) {
  customElements.define('km-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = [...this.querySelectorAll('.km-review-card')];
      this.controls = this.querySelector('.km-review-controls');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.page = 0;
      this.paused = this.dataset.autoplay !== 'true' || this.reducedMotion.matches;
      this.hovered = false;
      this.focused = false;
      this.abort = new AbortController();
      const listen = (target, event, callback) => target.addEventListener(event, callback, { signal: this.abort.signal });
      listen(this.querySelector('[data-prev]'), 'click', () => this.move(-1));
      listen(this.querySelector('[data-next]'), 'click', () => this.move(1));
      listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      listen(this, 'focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.mobile, 'change', () => { this.page = 0; this.render(); this.schedule(); });
      listen(this.reducedMotion, 'change', () => {
        if (this.reducedMotion.matches) this.paused = true;
        this.schedule();
      });
      listen(this, 'shopify:block:select', event => {
        const card = event.target.closest('.km-review-card');
        const index = this.cards.indexOf(card);
        if (index < 0) return;
        this.editorSelected = true;
        this.page = index;
        this.render(); this.schedule();
      });
      listen(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); });
      this.controls.hidden = this.cards.length < 2;
      this.render(); this.schedule();
    }
    get perPage() { return 1; }
    get pageCount() { return Math.ceil(this.cards.length / this.perPage); }
    render(announce = false) {
      this.querySelector('.km-review-grid').setAttribute('aria-live', announce ? 'polite' : 'off');
      const start = this.page * this.perPage;
      this.cards.forEach((card, i) => { card.hidden = i < start || i >= start + this.perPage; });
    }
    move(direction, automatic = false) {
      if (!this.pageCount) return;
      this.page = (this.page + direction + this.pageCount) % this.pageCount;
      this.render(!automatic);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.editorSelected && !this.paused && !this.hovered && !this.focused && !document.hidden && this.pageCount > 1) {
        this.timer = setTimeout(() => this.move(1, true), Number(this.dataset.interval) || 6000);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.initialized = false;
    }
  });
}
